import { SectionClient, SectionModel } from "@/Generated/ParticaAPI";

export interface ISectionService {
	getSections(TitleId: number): Promise<SectionModel[]>;
	saveSection(data: SectionModel): Promise<SectionModel>;
}

export class SectionService implements ISectionService {
	private svc: SectionClient = new SectionClient();
	public async getSections(TitleId: number): Promise<SectionModel[]> {
		return await this.svc.getSectionsForPublication(TitleId);
	}
	public async saveSection(data: SectionModel): Promise<SectionModel> {
		if (data.id === 0) {
			return await this.svc.addSection(data);
		} else {
			return await this.svc.updateSection(data);
		}
	}
}
